export interface Events {
  sn: string;
  timeZone?: number;
  gId?: number;
  dcode: number;
  acode?: number;
  regionId?: number;
  IsMsp?: boolean;
  event: [{
    ts: Date;
    event_number?: number;
    ErrorCode?: string;
    LevelCode?: string;
    IsHardwareOccur?: boolean;
  }];
  DeviceSubType?: number;
  DisplaySourceType?: number;
  SourceType?: number;
}

export interface EventsParams {
  otp: string;
  startDate: Date;
  endDate: Date;
  RegionIds?: number[];
  dcode?: number;
}

export interface FilterParams {
  deviceName: string;
  status: number;
  sn: string;
  type?: string;
  filterId?: any;
}

export interface EventMaps {
  num: number;
  statusType: string;
  status: number;
  desc: string;
}

export interface EventMonitoringFilter {
  otp?: string;
  regionId?: number;
  device_status?: number;
  startDate?: Date;
  endDate?: Date;
  acode?: number;
  dcode?: number;
  DeviceSubType?: any;
}

export interface HardwareFaultLevels {
  Level: number;
  LevelCode: string;
  ColorCode: string;
  Note: string;
}

export interface HardwareFaultCodes {
  ErrorCode: string;
  Description: string;
  Note: string;
}
